import { AbsgArrayHelper } from '@absg/angular-common';
import { AccessPointApi } from '@absg/api-station-management';
import { AccessPointDoorState, ModbusAccessPointNotification, NimAlertService, StorageAccessPoint } from '@absg/nim-client-shared';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AccessPointService } from 'core.services/access-point/access-point.service';
import { LockAccessService } from 'core.services/access-point/lock-access.service';
import { BehaviorSubject } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';

@Component({
  selector: '[nc-door-access-modal]',
  templateUrl: './door-access.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DoorAccessModalComponent {
  @Input() set hotKeyTriggered(trigger: boolean) {
    this.isModalOpen.next(trigger);
    if (trigger) {
      this.onModalOpen();
    }
  }
  @Output() closeModal = new EventEmitter<boolean>();
  isModalOpen = new BehaviorSubject(false);
  selectedAccessPoint: StorageAccessPoint = null;
  accessPoints: StorageAccessPoint[] = [];
  showSearchSpinner$ = new BehaviorSubject(false);

  constructor(
    private accessPointApi: AccessPointApi,
    private accessPointService: AccessPointService,
    private lockService: LockAccessService,
    private alertService?: NimAlertService,
  ) { }

  selectAc(accessPoint: StorageAccessPoint): void {
    this.selectedAccessPoint = accessPoint;
  }

  onModalOpen(): void {
    this.accessPointApi.getAccessPointsForStation().pipe(
      take(1),
      map((accessPoints: StorageAccessPoint[]) => {
        this.accessPoints = AbsgArrayHelper.sortBy(accessPoints, (ac) => ac.sequence);
      }),
      finalize(() => this.showSearchSpinner$.next(false)),
    ).subscribe();
  }

  close(): void {
    this.isModalOpen.next(false);
    this.closeModal.emit(false);
  }

  failAccessPoint(): void {
    const failedMessage = new ModbusAccessPointNotification(this.selectedAccessPoint.id, AccessPointDoorState.Open, 'dev-fail');
    failedMessage.failureFlag = true;
    failedMessage.isResolvedDoor = false;
    this.lockService.accessPointStateChangedNotification.next(failedMessage);
    this.closeModal.emit(false);
    this.selectedAccessPoint = null;
  }

  unlockAccessPoint(): void {
    this.accessPointService.unlockAccessPoint(this.selectedAccessPoint.id);
    this.alertService.showCloseDoorPrompt(this.selectedAccessPoint.name);
    this.closeModal.emit(false);
    this.selectedAccessPoint = null;
  }

  trackItem(__: number, item: StorageAccessPoint): number {
    if (!item) { return undefined; }
    return item.id;
  }
}
